
<!-- 儿童个人信息保护规则 -->
<template>
  <div class="wraper">
    <div style="white-space:pre-wrap">
      <div class="big">
        本规则生效日期：2022年 04月 28日
      </div>
      <div class="part big">
        深圳市丰驰顺行信息技术有限公司及其关联方（以下简称“顺丰”或“我们”）深知儿童（本规则中指未满十四周岁的未成年人）个人信息和隐私保护的重要性。《儿童个人信息保护规则》（以下简称“本规则”）为我们基于所提供的顺陆APP、微信公众号、小程序等服务（以下简称“本服务”）所制定的《顺丰运力用户服务协议》以及《隐私协议》的不可分割的组成部分，除非《儿童个人信息保护规则》另有约定，本规则中的定义与《顺丰运力用户服务协议》《隐私协议》一致。
      </div>
      <div class="part big">
        <div class="big">【适用范围】</div>
        <div class="big">本规则旨在说明当本服务涉及处理儿童个人信息时，我们特别针对儿童（或称“您的孩子”）所制定、施行的个人信息保护政策，作为儿童的监护人（下称“您”），您可通过本规则知悉和理解我们如何收集、使用、存储和共享您的孩子的个人信息，以及儿童及其监护人所享有的相关权利。我们将根据本规则采取特殊措施保护儿童的个人信息。<br>
        本规则仅适用于未满十四周岁、不能单独决定和授权我们处理其个人信息的未成年人。作为已满十四周岁未满十八周岁的青少年，其本人或您作为其监护人均有权决定是否根据《隐私协议》的约定授权我们处理该青少年的个人信息。</div>
      </div>
      <div class="part big">
        <div class="big">【特别说明】</div>
        <div class="big">监护人应认真阅读、充分理解并同意本规则后指导儿童使用相关服务。我们采用实名认证执行对未成年人（包括儿童）的相关保护措施，我们也将参考业内良好实践获得监护人的授权和同意。除非法律法规另有明确要求，我们将基于您的同意按照本规则的规定处理和保护儿童个人信息。若您拒绝同意本规则的，儿童将无法获得使用本服务的许可。当儿童年满14周岁并申请我们核验其身份后，其有权管理自身账号，届时监护人将不再享有访问和控制该账号的权利。</div>
      </div>
      <div class="part big">
        <div class="big">本规则将从以下几个方面就儿童个人信息保护的特殊规则予以说明：</div>
        <div class="big">1、我们如何收集儿童个人信息</div>
        <div class="big">2、我们如何使用儿童个人信息</div>
        <div class="big">3、我们对儿童个人信息的委托处理和转移</div>
        <div class="big">4、我们如何对外披露儿童个人信息</div>
        <div class="big">5、我们如何存储儿童个人信息</div>
        <div class="big">6、我们如何保障儿童个人信息的安全</div>
        <div class="big">7、您如何管理儿童的个人信息</div>
        <div class="big">8、本规则的变更</div>
        <div class="big">9、儿童个人信息保护负责机构</div>
        <div class="big">10、《隐私协议》适用</div>
      </div>
      <div class="part">
        <div class="big">1、我们如何收集儿童个人信息</div>
        <div class="">在向儿童提供本服务的过程中，我们所收集的儿童个人信息范围与《隐私协议》说明的基本业务功能和扩展业务功能所需的必要个人信息和非必要个人信息范围一致，目的是为了向儿童提供适当服务内容以及保障儿童账户安全。</div>
        <div class="">
          此外，我们为了验证您与儿童的监护关系的真实性以及确保监护人身份的真实性，我们可能还会需要收集您作为<text class="big">监护人的联系方式（手机号码和/或电子邮箱）</text>以及其他必要的、合理的、且有助于我们判断<text class="big">监护关系真实性及监护人身份真实性</text>的信息。
          <text class="big">请您特别注意，您的孩子还可以通过登录他所注册的与我们合作的渠道方(例如应用商店或渠道、微信等)的相关账户注册和登录使用本服务，此时我们会从渠道方获取您的孩子在该第三方账号项下的相关信息，包括账户名称、账户昵称(但不包括实名认证信息等)。就该渠道方所收集的您的孩子的个人信息，适用渠道方的儿童个人信息保护政策或相关声明。
          为保护您孩子的个人信息安全，我们再次提示全部注册过程，包括上述第三方账号授权登录过程，全部应由您来指导孩子完成。</text>
        </div>
      </div>
      <div class="part">
        <div class="big">2、我们如何使用儿童个人信息</div>
        <div class="">我们严格遵守国家法律法规以及政策的规定，并恪守《隐私协议》的约定在授权同意的范围内使用收集的信息，为儿童提供本服务。若我们使用儿童的个人信息，超出了《隐私协议》的范围或超出了我们收集儿童信息时告知的目的及具有直接或合理关联的范围，我们将在使用儿童的个人信息前，再次向您告知并征得您的同意。</div>
      </div>
      <div class="part">
        <div class="big">3、我们对儿童个人信息的委托处理和转移</div>
        <div class="">我们如需委托第三方处理儿童个人信息的，将对受委托方及委托行为等进行安全评估，签署委托协议，明确处理事项、处理期限、处理性质和目的及双方责任等，委托处理行为不会超出您授权我们处理儿童信息的范围。委托处理情形下，我们将会对儿童的个人信息保护承担责任，监督和要求受委托方履行如下义务：</div>
        <div class="">1.按照法律、行政法规的规定和我们的要求处理儿童个人信息；</div>
        <div class="">2.协助我们回应儿童监护人提出的申请；</div>
        <div class="">3.采取措施保障信息安全，并在发生儿童个人信息泄露安全事件时，及时向我们反馈；</div>
        <div class="">4.要求在委托关系解除时及时删除儿童个人信息；</div>
        <div class="">5.不得转委托；</div>
        <div class="">6.其他依法应当履行的儿童个人信息保护义务。</div>
        <div class="">我们转移儿童个人信息的场景和必要性详见《隐私协议》。我们仅会出于合法、正当、必要的目的向第三方提供儿童的个人信息。</div>
        <div class="">我们将在委托处理或转移儿童个人信息时自行或者委托第三方机构进行安全评估，并采用加密和其他技术措施保障儿童信息安全。</div>
      </div>
      <div class="part">
        <div class="big">4、我们如何对外披露儿童个人信息</div>
        <div class="">我们仅基于法律、行政法规规定应当披露或者根据与您的约定的情况下，才会披露您的孩子的个人信息，更多具体规定详见《隐私协议》。</div>
      </div>
      <div class="part">
        <div class="big">5、我们如何存储儿童个人信息</div>
        <div class="">我们严格按照法律法规和监管政策的规定，对儿童个人信息的存储采取符合业内标准的加密措施以保护儿童个人信息安全。</div>
        <div class="">一般情况下，我们只会在为实现必要的服务目的所必需的时间内或法律法规规定的条件下存储您的孩子的个人信息。在超出法律法规或监管规定的期限后，我们会按照法律法规的要求对您的孩子的个人信息进行删除或者采取脱敏技术措施进行匿名化处理。</div>
      </div>
      <div class="part">
        <div class="big">6、我们如何保障儿童个人信息的安全</div>
        <div class="">1.对儿童个人信息的存储、传输、转移采取加密或其他必要的技术措施；</div>
        <div class="">2.委托第三方处理或向第三方转移时进行安全评估；</div>
        <div class="">3.为了保障儿童个人信息安全，我们严格要求可以接触儿童个人信息的人员遵守保密义务、不得随意访问、使用儿童个人信息，采取技术措施，避免该等人员违法复制、下载儿童个人信息。</div>
      </div>
      <div class="part">
        <div class="big">7、您如何管理儿童的个人信息</div>
        <div class="">您可以根据《隐私协议》中告知的途径实现个人信息主体权利，通过对您的孩子的账户行使更改、删除等权利，以保护您孩子的信息安全及身心健康。</div>
      </div>
      <div class="part">
        <div class="big">8、本规则的变更</div>
        <div class="">我们可能会适时根据国家法律法规、监管政策以及技术环境的变更对本规则进行修订、调整。当本规则具体内容发生变更时，我们会在版本更新时以适当的方式向您提示变更后的规则。请您仔细阅读变更后的儿童个人信息保护规则，您许可您的孩子继续使用本服务即表示您同意我们按照更新后的规则收集、使用或处理您的孩子的个人信息。</div>
      </div>
      <div class="part">
        <div class="big">9、儿童个人信息保护负责机构</div>
        <div class="">我们设有专门的个人信息保护机构，该机构将严格按照本规则承担起儿童个人信息保护义务。如有关于儿童个人信息安全的投诉和举报，或对本规则的相关事宜有任何问题、意见或建议，请随时与我们的个人信息保护负责部门联系：</div>
        <div class="">联系地址：中国广东省深圳市南山区学府路深圳软件产业基地一栋B座一楼</div>
        <div class="">电子邮箱：DPO@sfmail.sf-express.com</div>
      </div>
      <div class="part">
        <div class="big">10、《隐私协议》适用</div>
        <div class="">本服务的《顺丰运力用户服务协议》及《隐私协议》是我们统一适用的用户服务协议和一般性隐私条款，其中所规定的内容包括但不限于用户权利及信息安全保障措施等均适用于全部用户。本规则是专门针对儿童用户的隐私保护政策，包含对于儿童个人信息的特殊保护。如本服务的《顺丰运力用户服务协议》及《隐私协议》与本规则存在不一致或矛盾之处，请以本规则为准。</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  created() {

  },
  mounted() {

  }
}
</script>
<style lang="less" scoped>
.wraper{
  width: 100%;
  height: 100%;
  padding: 46px 37px;
  box-sizing: border-box;
  font-size: 14px;
  color: #252945;
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 400;
  color: #000000;
  word-break: break-all;
}
.big{
  font-weight: 600;
}
.part{
  margin-top: 21px;
}
</style>